import script from "./ConfluenceWorkspaceSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfluenceWorkspaceSelect.vue?vue&type=script&setup=true&lang=js"

import "./ConfluenceWorkspaceSelect.vue?vue&type=style&index=0&id=7699fa4e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7699fa4e"]])

export default __exports__